// extracted by mini-css-extract-plugin
export default {"root":"UploadImage_root__yQ6Hb","image":"UploadImage_image__535je","fakeImage":"UploadImage_fakeImage__yfy2B"};